module.exports = __webpack_public_path__ + "img/teacher2.c02010ca.png";